// extracted by mini-css-extract-plugin
export var container = "styles-module--container--2-M1T";
export var subtitle = "styles-module--subtitle--xkL-5";
export var title = "styles-module--title--2x6eV";